<template>
  <main class="py-4">
    <AppLoading v-if="isLoading" />
    <CommonSwiper
      v-else-if="roomImageUrls.length"
      ref="roomImagesSwiper"
      :swiperSlides="roomImageUrls"
      :options="swiperOptions"
      :swiperStyle="{ width: 'calc(100vw - 700px)' }"
      :loading="isUploadingImage"
      class="mb-3"
    >
      <template #slide="{ slide: imageUrl }">
        <img
          :src="imageUrl"
          class="img-thumbnail img-fluid"
          alt=""
        />
      </template>
    </CommonSwiper>
    <p v-else class="text-muted text-center font-italic">No Images Found</p>
    <div class="row">
      <div class="col">
        <AppButtonWithLoader
          v-if="editable"
          :loading="isUploadingImage"
          :disabled="isUploadingImage"
          @click="$refs.fileInput.click()"
        >
          <template #default>
            <AppIcon name="cloud_upload" class="mr-2"
            />
            Upload image
          </template>
          <template #loading>
            <AppIcon name="autorenew" class="spin mr-2" />
            Uploading
          </template>
        </AppButtonWithLoader>
        <input
          ref="fileInput"
          type="file"
          class="d-none"
          @change="uploadImage"
        />
      </div>
      <div class="col">
        <AppButtonWithLoader
          v-if="roomImageUrls.length > 0"
          :loading="isDeletingImage"
          :disabled="isDeletingImage"
          variant="danger"
          class="ml-auto"
          @click="deleteImage"
        >
          <template #default>
            <AppIcon name="delete_outline" class="mr-2" />
            Delete image
          </template>
          <template #loading>
            <AppIcon name="autorenew" class="spin mr-2" />
            Deleting...
          </template>
        </AppButtonWithLoader>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import { uploadToS3 } from '@/api'
import CommonSwiper from '@/components/Common/CommonSwiper'

export default {
  components: { CommonSwiper },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isUploadingImage: false,
    isDeletingImage: false,
  }),
  computed: {
    ...mapGetters([ 'school', 'roomById' ]),
    room () {
      return this.roomById(this.$route.params.roomId)
    },
    roomImageUrls () {
      return (this.room.imageUrls || [])
    },
    isLoading () {
      return !this.room._id
    },
    swiperOptions () {
      return {
        allowSlidePrev: this.roomImageUrls.length > 1,
        allowSlideNext: this.roomImageUrls.length > 1,
      }
    },
  },
  methods: {
    // TODO: Based on `AddOrEditEmailTemplateModal` component, make more reusable at some point
    async uploadImage () {
      try {
        this.isUploadingImage = true
        const image = this.$refs.fileInput.files[0]
        this.$refs.fileInput.value = null
        const imageUrl = await uploadToS3({
          school: this.school,
          file: image,
          bucketName: 'coursedog-images-public',
        })
        await this.$store.dispatch('setRoom', {
          ...this.room,
          // We don't want to have a query with signedUrl stuff, so just cut after '?'
          imageUrls: [ ...this.roomImageUrls, imageUrl.split('?')[0] ],
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.isUploadingImage = false
      }
    },
    async deleteImage () {
      try {
        this.isDeletingImage = true
        // This looks ugly, but seems like the only way to retrieve `activeIndex` of Swiper
        const imageIndex = this.$refs.roomImagesSwiper.$refs.swiper.swiper.activeIndex
        const imageUrls = this.roomImageUrls.filter(imageUrl => imageUrl !== this.roomImageUrls[imageIndex])
        await this.$store.dispatch('setRoom', { ...this.room, imageUrls })
      } catch (err) {
        console.error(err)
      } finally {
        this.isDeletingImage = false
      }
    },
  },
}
</script>
